import { inject } from 'inversify';
import { urlMaker } from '@core/utils';
import { IRepo, IRepoResponse } from '@core/repo';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { bind } from '@infra/container';

import { IBranchSelect } from '../interfaces';
import { BranchMapper } from '../mappers';

export type IGetBranchesSelectRepoResponse = IRepoResponse<200, IBranchSelect[]> | IRepoResponse<400 | 500, string>;

export type IGetBranchesSelectRepo = IRepo<[], IGetBranchesSelectRepoResponse>;

export const GetBranchesSelectRepoType = Symbol.for('GetBranchesSelectRepo');

@bind(GetBranchesSelectRepoType)
export class GetBranchesSelectRepo implements IGetBranchesSelectRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute() {
    try {
      const result = await this.httpClient.get({ url: urlMaker('/api/admin/branches/select') });
      if (result.status === 200) {
        const data: IBranchSelect[] = result.data?.data?.map((elem) => BranchMapper.selectToDomain(elem));

        return {
          status: 200 as 200,
          response: data,
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi',
      };
    }
  }
}
